
// get GroupCate_CusRatePrice
export const Action_GetGroupCate_CusRatePrice = "Action_GetGroupCate_CusRatePrice";
export const Action_GetGroupCate_CusRatePriceSuccess = "Action_GetGroupCate_CusRatePriceSuccess";
// save GroupCate_CusRatePrice
export const Action_SaveGroupCate_CusRatePrice = "Action_SaveGroupCate_CusRatePrice";
export const Action_SaveGroupCate_CusRatePriceSuccess = "Action_SaveGroupCate_CusRatePriceSuccess";
export const Action_SaveGroupCate_CusRatePriceFailed = "Action_SaveGroupCate_CusRatePriceFailed";
// delete GroupCate_CusRatePrice
export const Action_DeleteGroupCate_CusRatePrice = "Action_DeleteGroupCate_CusRatePrice";
export const Action_DeleteGroupCate_CusRatePriceSuccess = "Action_DeleteGroupCate_CusRatePriceSuccess";
export const Action_DeleteGroupCate_CusRatePriceFailed = "Action_DeleteGroupCate_CusRatePriceFailed";

